import React, {} from 'react';

import { normalizeFourSideValues } from '../utilities';

import FourInputs from '../four-inputs';

function FourSides(props) {

  function renderMain() {

    const fourSidesProperties = {
      values: normalizeFourSideValues(props.values),
      labels: ['TOP', 'RIGHT', 'BOTTOM', 'LEFT'],
      onChange: props.onChange
    };

    return <FourInputs {...fourSidesProperties} />;

  }

  return renderMain();

}

export default FourSides;